import { API_ROUTES } from "../../configuration/RoutesApi"
import { useError } from "../../context/useErrorContext"
import { useLoad } from "../../context/useLoadContext"
import { NoticeEntity } from "../../Objects/Notice/NoticeEntity"
import { PostFormRequest, PutFormRequest } from "../../services/ApiClientService"
import { useGetNotice } from "./useGetNotice"
import { useTranslation } from "react-i18next"
import { toInputDate } from "../../Objects/Generics/Helps"

export const useSaveNotice = () => {
  const { t } = useTranslation("general")

  const { enableLoad, disableLoad } = useLoad()

  const { setError } = useError()

  const { handleGetNotice } = useGetNotice()

  const handleSaveNotice = async (notice: NoticeEntity, fileImage: Blob | File | null, onSuccess: any) => {
    try {
      enableLoad()

      const payload = {
        id: notice.id,
        name: notice.name,
        description: notice.description,
        status: notice.status,
        startDate: toInputDate(notice.startDate),
        endDate: toInputDate(notice.endDate),
        Icon: fileImage || undefined,
      }

      let response = null
      if (notice.id !== -1) {
        response = await PutFormRequest(`${API_ROUTES.NOTICE.PUT}/${notice.id}`, payload)
      } else {
        response = await PostFormRequest(API_ROUTES.NOTICE.CREATE, payload)
      }

      if (response.success) {
        await handleGetNotice(onSuccess)
        return
      }

      throw new Error(response.message)
    } catch (e: unknown) {
      const message = e instanceof Error ? e.message : t("label_unknown_error_description")
      setError(t("label_title_erro"), message)
    } finally {
      disableLoad()
    }
  }

  return { handleSaveNotice }
}
